import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { getErrorMessage } from "@/lib/auth";
import { homePath } from "@/lib/access";

const API = `${window.location.origin}/api`;

export default function AuthCallback({ onAuth }) {
  const location = useLocation();
  const navigate = useNavigate();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
    axios.post(`${API}/auth/google/session`, { session_id: sessionId })
      .then((res) => {
        onAuth(res.data);
        toast.success(`Welcome, ${res.data.name}!`);
        navigate(homePath(res.data), { replace: true });
      })
      .catch((err) => {
        toast.error(getErrorMessage(err));
        navigate("/", { replace: true });
      });
  }, [location.hash, navigate, onAuth]);

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-50" style={{ minHeight: "100dvh" }} data-testid="google-auth-callback">
      <div className="w-8 h-8 border-2 border-indigo-500 border-t-transparent rounded-full animate-spin" />
    </div>
  );
}
